/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { AppState } from 'src/app/store/app.reducer';
import { MtmaRule, MtmaRuleAccess } from 'src/app/model/mtma-rules-access';
import * as DeviceActions from 'src/app/store/device/device.actions';
import { Subscription } from 'rxjs';
import { MtmaTag } from 'src/app/model/mtma-tag';
import { MtmaKeypad } from 'src/app/model/mtma-keypad';
import { MtmaContact } from 'src/app/model/mtma-contact';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { StandardNewValidator, StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	selector: 'app-mtma-rule-access-dialog',
	templateUrl: './mtma-rule-access-dialog.component.html',
})

export class MtmaRuleAccessDialogComponent implements OnInit, OnDestroy {
	rule: MtmaRule;

	mtmaRuleModifySub: Subscription;

	ruleAccessForm: FormGroup;

	listContactsAll: MtmaContact[];
	listContactsAllSub: Subscription;

	listTagsAll: MtmaTag[];
	listTagsAllSub: Subscription;

	listKeypadsAll: MtmaKeypad[];
	listKeypadsAllSub: Subscription;

	listTagSub: Subscription;
	listKeypadSub: Subscription;
	listContactSub: Subscription;

	// design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	MAX_MD_WIDTH = 1120;
	MIN_WIDTH_COL4 = 1680;
	DELTA_ERROR_PIXEL = 7;
	MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

	constructor(
		private fb: FormBuilder,
		private store: Store<AppState>,
		public config: DynamicDialogConfig,
		private ref: DynamicDialogRef,
	) {
		if (config.data !== undefined && config.data.rule !== undefined) {
			this.rule = config.data.rule;
		}
	}

	ngOnInit(): void {
		this.ruleAccessForm = this.fb.group({
			'contacts': new FormControl(''),
			'keypads': new FormControl(''),
			'tags': new FormControl(''),
		});

		this.mtmaRuleModifySub = this.store.select('device', 'mtmaRuleModify')
			.pipe(filter(mtmaRuleModify => !!mtmaRuleModify))
			.subscribe(() => {
				this.resetClose();
			});

		this.store.dispatch(DeviceActions.getMtmaContactsAll());
		this.listContactsAllSub = this.store.select('device', 'mtmaContactsAll').subscribe(listContactsAll => {
			this.listContactsAll = listContactsAll;
		});
		this.store.dispatch(DeviceActions.getMtmaTagsAll());
		this.listTagsAllSub = this.store.select('device', 'mtmaTagsAll').subscribe(listTagsAll => {
			this.listTagsAll = listTagsAll;
		});
		this.store.dispatch(DeviceActions.getMtmaKeypadsAll());
		this.listKeypadsAllSub = this.store.select('device', 'mtmaKeypadsAll').subscribe(listKeypadsAll => {
			this.listKeypadsAll = listKeypadsAll;
		});

		this.store.dispatch(DeviceActions.getMtmaRulesAccess({ ruleId: this.rule.Id }));
		this.listTagSub = this.store.select('device', 'mtmaTagsRule').subscribe(listTag => {
			this.ruleAccessForm.get('tags').patchValue(listTag);
		});
		this.listKeypadSub = this.store.select('device', 'mtmaKeypadsRule').subscribe(listKeypad => {
			this.ruleAccessForm.get('keypads').patchValue(listKeypad);
		});
		this.listContactSub = this.store.select('device', 'mtmaContactsRule').subscribe(listContact => {
			this.ruleAccessForm.get('contacts').patchValue(listContact);
		});

		this.store.dispatch(DeviceActions.getMtmaRulesAccess({ ruleId: this.rule.Id }));

		this.onResize();
	}

	ngOnDestroy(): void {
		this.listContactsAllSub?.unsubscribe();
		this.listTagsAllSub?.unsubscribe();
		this.listKeypadsAllSub?.unsubscribe();
		this.listTagSub?.unsubscribe();
		this.listKeypadSub?.unsubscribe();
		this.listContactSub?.unsubscribe();
	}

	resetClose(): void {
		this.store.dispatch(DeviceActions.resetMtmaRulesAccessForm());
		this.closeDialog();
	}

	submit(): void {
		const ruleAccess = new MtmaRuleAccess();
		ruleAccess.Contacts = this.f.contacts.value;
		ruleAccess.Tags = this.f.tags.value;
		ruleAccess.Keypads = this.f.keypads.value;
		this.store.dispatch(DeviceActions.editMtmaRulesAccess({ ruleId: this.rule.Id, ruleAccess }));
	}

	get f(): any {
		return this.ruleAccessForm.controls;
	}

	closeDialog(): void {
		this.ref.close();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-23rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: MtmaRuleAccessDialogComponent["f"], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: MtmaRuleAccessDialogComponent["f"]): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

}
